module.exports = __webpack_public_path__ + "img/share.41c3914b.png";